import styled from '@emotion/styled';

export const ProductCardListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;

  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.laptop + 'px'}){
     grid-template-columns: repeat(1, 1fr);
  }
`;
